import { Modal } from "@website/ui/modal";
import { Login } from "@website/widget/login/login";
import { useLoginModal } from "@website/widget/login/use-login-modal";

export const LoginModal = () => {
  const { loginModalProps, onLoginModalClose, onLoginModalEnd } =
    useLoginModal();
  return (
    <Modal className="scroll-mt-[100px]" {...loginModalProps} usePortal>
      <Login onClose={onLoginModalClose} onEndAuth={onLoginModalEnd} />
    </Modal>
  );
};
